<template>
	<div class="w-full h-full">
		<ActiveSessionsModal
			v-if="check_sessions"
			ref="active_sessions"
		/>
		<MaintenanceModal />
		<SelectStamp
			:open="stampModalOpen" 
			@selected="OnStampSelected" 
			@close="stampModalOpen = false" 
		/>
		<div class="w-full justify-content-start">
			<Menu :carousel="carousel" />
		</div>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex'
	import Menu from './Menu'
	import ActiveSessionsModal from './ActiveSessionsModal'
	import MaintenanceModal from '../layout/MaintenanceModal'
	import SelectStamp from '../layout/sections/modals/SelectStamp'

	export default {
		name: 'Home',
		components: {
			Menu,
			ActiveSessionsModal,
			MaintenanceModal,
			SelectStamp
		},
		props: {
			check_sessions: {
				type: Boolean,
				default: false,
			},
			carousel: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				stampModalOpen: false,
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id', 'requesters', 'requester_needs_stamp_selection']),
			getEngineOrganization() {
				return parseInt(process.env.VUE_APP_ENGINE_ORGANIZATION_ID)
			},
			is_confirmed() {
				const is_confirmed =
					this.requesters.find(
						r =>
							r.account_requester_id == this.requester_selected_id
					)?.confirmed ?? false

				if (
					this.requester_selected_id &&
					!is_confirmed &&
					!this.getEngineOrganization
				) {
					this.$router.push({ name: 'Organizations' })
				}

				return is_confirmed
			},
		},
		watch: {
			is_confirmed: {
				handler(val) {
					if (
						this.requester_selected_id &&
						!val &&
						!this.getEngineOrganization
					) {
						this.$router.push({ name: 'Organizations' })
					}
				},
			},
			requester_selected_id: {
				handler(val) {
					if (val == this.getEngineOrganization) {
						this.$router.push({ name: 'Engine' })
					}
				},
				immediate: true,
			},
			requester_needs_stamp_selection: {
				handler(val) {
					const is_engine = this.requester_selected_id == this.getEngineOrganization

					this.stampModalOpen = val && !is_engine
				},
				immediate: true
			},
		},
		methods: {
			...mapActions('auth', ['SetRequesterAccount']),
			async HandleSessionData() {
				if (!this.$route.query?.session_data) return

				const session_data = JSON.parse(this.$route.query.session_data)

				if (session_data) {
					this.$router.replace({ query: null })

					window.session_data = session_data

					if (session_data.is_redirect) {
						localStorage.setItem('token', session_data.token)

						const requester = this.requesters.find(
							r => r.id == session_data.requester_id
						)

						if (requester) {
							this.SetRequesterAccount(requester)
						}
					}
				}
			},
			OnStampSelected(stamp) {
				this.stampModalOpen = false

				if (this.$route.name !== 'Home') {
					this.$router.push({ name: 'Home' })
				}
			},
		},
		mounted() {
			this.HandleSessionData()
		},
	}
</script>

<style></style>
